import { useSelector } from 'react-redux'

import { useSelectedClientData } from './useSelectedClientData'
import { getRequestPaymentCustomersByCountry } from '../../../../../data/requestPayment/requestPaymentSelectors'

export const useCustomersForClient = () => {
  const customersByCountry = useSelector(getRequestPaymentCustomersByCountry)
  const { data: clientDetails } = useSelectedClientData()
  if (!clientDetails?.country) {
    return []
  }
  return customersByCountry?.[clientDetails?.country] ?? []
}
